import { AlertIconWithOrangeBg, NavCloseIcon } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

interface InvoiceRiskWarningsPopupProps {
  open: boolean;
  warnings: string[];
  onCreateAnyway: VoidFn;
  onGotIt: VoidFn;
  isEdit?: boolean;
  isLoading?: boolean;
}

const InvoiceRiskWarningsPopup: FC<InvoiceRiskWarningsPopupProps> = ({
  open,
  warnings,
  onCreateAnyway,
  onGotIt,
  isEdit = false,
  isLoading = false
}) => {
  if (!open) {
    return null;
  }

  const primaryLabel = isEdit ? 'Save anyway' : 'Create anyway';

  return (
    <CustomModal open={true} width="md:w-[335px]">
      <div className="relative">
        <div
          className="absolute right-2.5 top-2.5 cursor-pointer"
          onClick={onGotIt}
          onKeyDown={e => e.key === 'Enter' && onGotIt()}
          role="button"
          tabIndex={0}
          aria-label="Close risk warnings popup">
          <NavCloseIcon />
        </div>
        <div className="flex flex-col items-center gap-3.5 px-8 py-4">
          <AlertIconWithOrangeBg />

          <div className="text-center text-17px font-semibold text-primaryText">Please review</div>
          <ul className="list-disc space-y-2 pl-5 text-sbase text-primaryText">
            {warnings?.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        </div>
        <div className="m-4 flex flex-col gap-2">
          <CustomButton
            id="invoice-risk-warnings-create-anyway"
            onClick={onCreateAnyway}
            className="h-10 w-full"
            disabled={isLoading}
            isLoading={isLoading}>
            {primaryLabel}
          </CustomButton>
          <CustomButton
            id="invoice-risk-warnings-got-it"
            onClick={onGotIt}
            className="h-10 w-full border border-borderGray bg-transparent text-primaryText hover:bg-borderGray">
            Got it
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default InvoiceRiskWarningsPopup;
